<template>
  <div id="app">
    <!-- <div class="information" ref="infor" v-if="isShow">
      <img src="@/assets/logo-text.svg" alt="" class="logo-img">
      <div class="qrcode">
        <img src="@/assets/qrCode.jpg" alt style="width:100%" />
      </div>
      <div class="informationzixun">
        <p>扫码关注公众号</p>
        <p>与在线客服直接沟通</p>
        <p><span class="iconfont icon-dianhua"></span></p>
        <p>客服热线</p>
        <p style="font-size:21px; font-weight: normal;">(0755) 8320 7865</p>
      </div>
      <div class="sizes" @click="onClick">
        <img src="@/assets/x.png" alt />
      </div>
    </div> -->
    <nav class="gather-nav">
      <!-- 整个导航条 -->
      <nav class="navbar navbar-default">
        <!-- 导航版心 -->
        <div class="container" style="justify-content: center;">
          <div class="navbar-header" style="width: 100%;">
            <!-- 将屏幕缩小到超小屏显示的按钮区域 -->
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
            >
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <!-- 页面的brand区域 -->
            <a class="navbar-brand" @click="logoclick">
              <h1 class="h1Title">蓝小助</h1>
              <span class="logo iconfont icon-ziyuan20"></span>
              <span class="logo-text"><span></span>让大批量普工招聘变简单</span>
              <!-- <img src="@/assets/logo@2x.png" alt /> -->
            </a>
          </div>
          <!-- 点击button展开的盒子 -->
          <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <!-- 对应左侧导航区域 -->
            <ul class="nav navbar-nav activelength navbar-right">
              <li class="actives" @click="onClickactive(0)">
                <router-link to="/" class="acticea">
                  <a>首页</a>
                </router-link>
                <span class="bottom"></span>
              </li>
              <li class="actives" @click="onClickactive(1)">
                <router-link to="/product" class="acticea">
                  <a>产品中心</a>
                </router-link>
                <span class="bottom"></span>
              </li>
              <li class="actives" @click="onClickactive(2)">
                <router-link to="/relation" class="acticea">
                  <a>公司介绍</a>
                </router-link>
                <span class="bottom"></span>
              </li>
              <!-- <li class="activess">
                <span class="iconfont icon-dianhua"></span>
                <span>（0755）8320 7865</span>
              </li> -->
            </ul>
          </div>
        </div>
      </nav>
    </nav>
    <transition :name="transitionName">
      <router-view class="concents" />
    </transition>

    <!-- 底部 -->
    <Bottom></Bottom>
    <!-- 返回顶部 -->
    <!-- <div class="backtotop" @click="backTop">
      <div class="img1 hidden-xs">
        <img src="@/assets/goback.png" alt />
        <p>返回顶部</p>
      </div>
      <div class="img2 visible-xs">
        <img src="@/assets/goback.png" alt />
      </div>
    </div> -->
  </div>
</template>

<script>
//底部
import Bottom from "@/components/Bottom/index.vue";
import { mapState, mapGetters, mapActions } from 'vuex'; //先要引入
import setRem from '@/utils/rem.js'

export default {
  name: "BasicLayout",
  components: {
    Bottom
  },
  data () {
    return {
      transitionName: "",
      scrollbar: 200,
      name: JSON.parse(sessionStorage.getItem("value")) || "home"
    };
  },
  created () {
    const url = window.location.pathname.split('/')[1]
    if (url === 'state') {
      this.onClickactive(3)
    }
  },
  computed: {
    ...mapState({
      isShow: state => state.visible
    })
  },
  beforeRouteEnter (to, from, next) {
    console.log(to.path);
    next()
  },
  watch: {
    $route (to, from) {
      console.log(to, from);
      if (to.path === '/home') {
        this.onClickactive(0)
      } else if (to.path === '/product') {
        this.onClickactive(1)
      } else if (to.path === '/relation') {
        this.onClickactive(2)
      }
      sessionStorage.setItem("value", JSON.stringify(to.name));
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    },
  },
  mounted () {
    window.onresize = () => {
      setRem()
    }
    //获取滚动高度判断是显示隐藏
    this.scrollTops();
    //当刷新页面时，不滚动无法触发scrollTops方法 不能拿到scrollbar的值 返回顶部默认会显示
    this.scrollbar <= 200 ? $(".backtotop").hide() : $(".backtotop").show();
    if (this.name == "home") {
      this.onClickactive(0);
    } else if (this.name == "product") {
      this.onClickactive(1);
    } else if (this.name == "solution") {
      this.onClickactive(2);
    } else if (this.name == "state") {
      this.onClickactive(3);
    } else if (this.name == "relation") {
      this.onClickactive(2);
    }
  },
  methods: {
    logoclick () {
      this.$router.push('home')
      this.onClickactive(0)
    },
    onClickactive (index) {
      //隐藏移动端点击之后可折叠元素
      $("#bs-example-navbar-collapse-1").collapse("hide");
      $(".navbar-brand").css({ color: "#008de8"})
      $(".activess").css({ color: "#008de8"})
      $(".navbar-default").css({ background: "#fff" })

      //切换点击过字体颜色
      $(".activelength li .acticea a").css({ color: "#555", fontWeight: 400 });
      $(".activelength li .acticea a")
        .eq(index)
        .css({ color: "#008DE8", fontWeight: 600 });
      //下边框动画
      $(".activelength li .bottom")
        .css({ background: "#008de8" })
        .stop()
        .animate({ width: "0%", transition: "0.5s" });
      $(".activelength li .bottom")
        .eq(index)
        .css({ background: "#008de8" })
        .stop()
        .animate({ width: "100%", transition: "0.5s" });
    },
    //滚动事件
    scrollTops () {
      $(window).scroll(() => {
        this.scrollbar = $(window).scrollTop();
        this.scrollbar <= 200 ? $(".backtotop").hide() : $(".backtotop").show();
      });
    },
    //返回顶部事件
    backTop () {
      $("html,body").animate({ scrollTop: 0 }, "slow");
      $(".backtotop")
        .delay("200")
        .animate({ bottom: "1000px", opacity: "0" }, "slow", function () {
          $(".backtotop").hide();
          $(".backtotop").css({ bottom: "50px", opacity: "1" });
        });
    },
    onClick () {
      this.$refs.infor.style.transition = "right 1s linear"
      this.$refs.infor.style.right = "-300px"
      setTimeout(() => {
        this.$store.commit('setvisible', false)
      }, 1000)
    },
  }
};
</script>

<style lang='less' scoped>
@media (min-width: 576px){
  .container, .container-sm {
    max-width: 1000px
  }
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 200ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
#app {
  .information {
    width: 200px;
    background: red;
    position: fixed;
    z-index: 777;
    top: 125px;
    border-radius: 15px;
    background: white;
    text-align: center;
    right: -300px;
    border: 1px solid #e5e5e5;
    .logo-img {
      margin-top: 25px;
      width: 39px;
      height: 53px;
    }
    .informationSpan {
      font-size: 16px;
    }
    .qrcode {
      width: 100%;
    }
    .informationzixun {
      width: 190px;
      background: linear-gradient(to bottom, #2361f3 0%, #499afa 100%);
      text-align: center;
      padding: 15px 0 10px;
      color: white;
      border-radius: 0 0 15px 15px;
      font-size: 15px;
      margin: 5px;
      .buttons {
        width: 80%;
        margin-top: 10px;
        background: white;
        border: none;
        color: #4290f9;
        font-size: 16px;
      }
    }
    .sizes {
      position: absolute;
      top: 5px;
      right: 0;
      width: 30px;
      height: 30px;
      transform: translateX(-50%);
      font-size: 30px;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
  }
  #bs-example-navbar-collapse-1 {
    padding-bottom: 32px;
    a {
      line-height: 96px;
    }
  }
  .navbar-default {
    padding: 0;
    background: linear-gradient(270deg, #083BFA 0%, #3784EF 100%);
    border: none;
    .navbar-nav{
      padding: 0 80px;
    }
  }
  //导航固定定位
  .gather-nav {
    width: 100%;
    height: 160px;
    // text-align: center;
    position: fixed;
    z-index: 999;
  }
  //内容区
  .concents {
    padding-top: 160px;
  }
  //返回顶部
  .backtotop {
    position: fixed;
    z-index: 999;
    bottom: 30px;
    right: 30px;
    cursor: pointer;
    text-align: center;
    background: #008de8;
    border-radius: 50%;
    .img1 {
      width: 65px;
      height: 65px;
      img {
        width: 35px;
        height: 35px;
        margin-top: 5px;
      }
      p {
        font-size: 9px;
        color: white;
      }
    }
    .img2 {
      width: 35px;
      height: 35px;
      img {
        width: 17px;
        height: 17px;
        margin-top: 10px;
      }
      p {
        font-size: 9px;
        color: white;
      }
    }
  }
  .navbar-brand {
    cursor: pointer;
    height: auto;
    padding: 0;
    color: #00a8ff;
    .h1Title {
      position: absolute;
      left: -9999999999999999px;
    }
    .logo {
      padding-top: 15px;
      height: 160px;
      font-size: 96px;
      margin-left: 30px;
      display: inline-block;
      padding-bottom: 17px;
      margin-right: 32px;
    }
    .logo-text {
      font-size: 32px;
      vertical-align: middle;
      >span {
        margin-right: 10px;
        border-left: 2px solid #00a8ff;
      }
    }
  }
  .navbar-toggle {
    padding: 16px 16px;
    margin: 38.4px 64px 38.4px 0;
    .icon-bar {
      width: 57.6px;
      height: 6.4px;
      margin: 6.4px 0;
    }
  }
  a {
    text-decoration: none;
  }
}
.actives {
  position: relative;
  .acticea {
    font-size: 48px;
    padding: 29px 0;
    box-sizing: border-box;
    a {
      color: #555;
      &:hover {
        color: #008de8;
      }
    }
  }
  .bottom {
    width: 0px;
    height: 2px;
    background: #008de8;
    position: absolute;
    left: 0;
    bottom: -1px;
    transition: all 0.1s ease-in;
  }
}
.activess {
  font-size: 20px;
  line-height: 65.5px;
  margin-left: 30px;
  color: #008de8;
}
</style>
<style>
.nav > li > a {
  padding: 0;
}
</style>

